import { defineStore } from 'pinia';
import { useToasts } from '@agentsoftware/spectre-ui';

export default defineStore('toast-queue', () => useToasts());
